export const enum CustomAttributeType {
  Text = 'Text',
  Integer = 'Integer',
  Decimal = 'Decimal',
  Date = 'Date',
  Boolean = 'Boolean',
  Option = 'Option',
  Separator = 'Separator',
}
